"use client"; // <-- required

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUser } from '../config/firebase';
import { auth } from '../config/firebase'; // ensure this is correctly exported
import { getIdToken, onAuthStateChanged } from 'firebase/auth';

const UserContext = createContext({ user: null, loading: true });

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    const token = await getIdToken(firebaseUser, true);
                    const userData = await getUser(token);
                    setUser({ ...userData, uid: firebaseUser.uid });
                } catch (error) {
                    console.error("Error fetching user:", error);
                    setUser(null);
                }
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe(); // Clean up the listener
    }, []);

    return (
        <UserContext.Provider value={{ user, loading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);

